import React, { useMemo } from "react";
import { useSelected } from "slate-react";
import { css } from "@emotion/css";
import InlineChromiumBugfix from "./InlineChromiumBugfix";

const allowedSchemes = ["http:", "https:", "mailto:", "tel:"];

const Link = ({ attributes, children, element }) => {
    const selected = useSelected();

    const safeUrl = useMemo(() => {
        let parsedUrl = null
        try {
            parsedUrl = new URL(element.url);
        } catch {}

        if (parsedUrl && allowedSchemes.includes(parsedUrl.protocol)) {
            return parsedUrl.href
        }
        return "about:blank"
    }, [element.url]);

    return (
        <a {...attributes} href={safeUrl} className={selected ? css`box-shadow: 0 0 0 3px #ddd;` : ""}>
            <InlineChromiumBugfix />
                {children}
            <InlineChromiumBugfix />
        </a>
    )
}

export default Link;